
  import createMeisterIcons from '../src/createMeisterIcons';

  const MessageAlt = createMeisterIcons("message-alt", [["path",{"fill":"currentColor","d":"M3.75 12A8.213 8.213 0 0 1 12 3.75 8.213 8.213 0 0 1 20.25 12c0 4.486-3.764 8.25-8.25 8.25A8.213 8.213 0 0 1 3.75 12m-1.5 0A9.713 9.713 0 0 1 12 2.25 9.713 9.713 0 0 1 21.75 12c0 5.314-4.436 9.75-9.75 9.75H4c-.47 0-.92-.16-1.255-.495S2.25 20.47 2.25 20zm4.527 8.25H4c-.13 0-.18-.04-.195-.055-.015-.016-.055-.065-.055-.195v-2.777a9.7 9.7 0 0 0 3.027 3.027","key":"db33224ccf54c07e23bf8a7430db237b155278ff","fillRule":"evenodd","clipRule":"evenodd"}]])

  export default MessageAlt
  